import { z } from "zod";

export const pendingSettingsSchema = z
  .object({
    pendingDate: z.date().nullish(),
    notify: z.boolean().nullish(),
    enabled: z.boolean(),
  })
  .refine((data) => !(data.enabled && !data.pendingDate), {
    message: "pendingDate is required if pending settings are enabled",
    path: ["pendingDate"],
  });

export type PendingSettings = z.infer<typeof pendingSettingsSchema>;

export const invalidContractWarningFormSchema = z
  .object({
    enabled: z.boolean(),
    contractFixDeadline: z.coerce.date().nullish(),
  })
  .refine((data) => !(data.enabled && !data.contractFixDeadline), {
    message: "contractFixDeadline is required if invalid contract warning is enabled",
    path: ["contractFixDeadline"],
  });

export type InvalidContractWarningFormValues = z.infer<typeof invalidContractWarningFormSchema>;
